import React, { useState } from 'react';
import { Auth } from 'aws-amplify';

import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import './signUp.css';
import { Link as RouterLink } from 'react-router-dom';
import { Link as MuiLink } from '@mui/material';
import SignUpCongragulations from '../components/succesful/SignUpCongragulations';

export const SignUp = ({ triggerAlert }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        confirmPassword: '',
        code: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [isConfirming, setIsConfirming] = useState(false);
    const [showCongragulations, setShowCongragulations] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    /*  const handleSignUp = async (e) => {
         e.preventDefault();
         setError('');
         setLoading(true);
 
 
         if (formData.password !== formData.confirmPassword) {
             setError('Passwords do not match');
             setLoading(false);
             return;
         }
 
         try {
             await Auth.signUp({
                 username: formData.email,
                 password: formData.password,
                 attributes: {
                     email: formData.email
                 }
             });
             setIsConfirming(true);
         } catch (err) {
             console.error('Error signing up:', err);
             setError(err.message || 'Error signing up');
         } finally {
             setLoading(false);
         }
     }; */
    const handleSignUp = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        if (formData.password !== formData.confirmPassword) {
            setError('Passwords do not match');
            setLoading(false);
            return;
        }

        try {
            await Auth.signUp({
                username: formData.email,
                password: formData.password,
                attributes: {
                    email: formData.email
                }
            });
            // Instead of setting isConfirming, show success message
            triggerAlert("success", "Your account has been created successfully. Please contact your administrator for account activation.", 10000);
            setShowCongragulations(true);
            // Optionally, disable the form or show a different view
            setLoading(true); // This will keep the form disabled
        } catch (err) {
            console.error('Error signing up:', err);
            setError(err.message || 'Error signing up');
            setLoading(false);
        }
    };

    const handleConfirmSignUp = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        console.log("handleConfirmSignUp", handleConfirmSignUp);
        try {
            //await Auth.confirmSignUp(formData.email, formData.code);
            await Auth.signIn(formData.email, formData.password);
            navigate('/dashboard');
        } catch (err) {
            console.error('Error confirming sign up:', err);
            setError(err.message || 'Error confirming sign up');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="signin-wrapper">
            <div className="signin-container">
                <div className="signin-header">
                    <h2>Sign Up</h2>
                    <p>Please sign up to your account</p>
                </div>
                {showCongragulations &&
                    <SignUpCongragulations loading={showCongragulations} />
                }
                <form onSubmit={handleSignUp}>
                    {error && (
                        <div className={`message-box ${error.includes('successfully') ? 'success-message' : 'error-message'}`}>
                            <i className={`fas ${error.includes('successfully') ? 'fa-check-circle' : 'fa-exclamation-circle'}`}></i>
                            {error}
                        </div>
                    )}



                    <div className="form-group">
                        <label htmlFor="email">Email Address</label>
                        <div className="input-container">
                            <i className="fas fa-envelope"></i>
                            <input
                                id="email"
                                type="email"
                                value={formData.email}
                                onChange={handleChange}
                                name="email"
                                placeholder="Enter your email"
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <div className="input-container">
                            <i className="fas fa-lock"></i>
                            <input
                                id="password"
                                type="password"
                                value={formData.password}
                                onChange={handleChange}
                                name="password"
                                placeholder="Enter your password"
                                required
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="confirmPassword">Confirm Password</label>
                        <div className="input-container">
                            <i className="fas fa-lock"></i>
                            <input
                                id="confirmPassword"
                                type="password"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                name="confirmPassword"
                                placeholder="Enter your password"
                                required
                            />
                        </div>
                    </div>
                    {/* {
                        isConfirming ? (
                            <div className="form-group">
                                <label htmlFor="code">Confirmation Code</label>
                                <input type="text" id="code" name="code" placeholder="Enter your confirmation code" required />
                            </div>
                        ) : null
                    } */}

                    <button type="submit" className="signin-button">
                        {isConfirming ? 'Confirm' : 'Sign Up'}
                    </button>
                    <div className="signin-footer">
                        <p>Already have an account? {' '}
                            <MuiLink
                                component={RouterLink}
                                to="/signin"
                                sx={{
                                    color: '#1976d2',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        textDecoration: 'underline',
                                    }
                                }}
                            >
                                Sign In
                            </MuiLink>
                        </p>
                    </div>
                </form>
            </div>
        </div>

    );
};
